export const getAtlassianStudioAgentCreateUrl = (siteId: string) =>
	`/studio/s/${siteId}/agents/create/overview`;

// helpers to generate urls to redirect from rovo to atlassian studio using the enrichment route in studio
const getAtlassianStudioRedirectBaseUrl = (siteId: string, agentId: string) =>
	`/studio/s/${siteId}/agents/enrich/rovo/agents/${agentId}`;

export const getAtlassianStudioAgentEditUrl = (siteId: string, agentId: string) =>
	`${getAtlassianStudioRedirectBaseUrl(siteId, agentId)}?redirect=${encodeURIComponent('/:agentId/overview')}`;

export const getAtlassianStudioAgentDuplicateUrl = (siteId: string, agentId: string) =>
	`${getAtlassianStudioRedirectBaseUrl(siteId, agentId)}?redirect=${encodeURIComponent('/create')}`;
